// selectors/registration.ts
import { createSelector } from '@reduxjs/toolkit';

// If you have a RootState type, import it, or declare it here:
import type { RootState } from '@/store/rootReducer';
import type { RegistrationState } from '@/types/auth/Auth';

// Root selector
export const selectRegistration = (state: RootState): RegistrationState => state.registration;

// Select individual fields
export const selectRegistrationStep = createSelector(
  selectRegistration,
  reg => reg.step
);

export const selectRegistrationData = createSelector(
  selectRegistration,
  reg => reg.data
);

export const selectRegistrationLoading = createSelector(
  selectRegistration,
  reg => reg.loading
);

export const selectRegistrationError = createSelector(
  selectRegistration,
  reg => reg.error
);

// Select registration status as an object (optional utility)
export const selectRegistrationStatus = createSelector(
  selectRegistration,
  reg => ({
    loading: reg.loading,
    error: reg.error,
    step: reg.step
  })
);
